import { render, staticRenderFns } from "./purchase-modal.vue?vue&type=template&id=b5468e98&scoped=true&"
import script from "./purchase-modal.vue?vue&type=script&lang=js&"
export * from "./purchase-modal.vue?vue&type=script&lang=js&"
import style0 from "./purchase-modal.vue?vue&type=style&index=0&id=b5468e98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5468e98",
  null
  
)

export default component.exports